import type { AdminAddressApiResponse, Currency, WalletProvider } from '@/types/payment'

export function resolveWalletDepositAddress(currency: Currency, provider: WalletProvider, adminAddresses?: AdminAddressApiResponse['data']): string | null {
	const currencyAddress = currency.admin_address?.trim()
	if (currencyAddress) {
		return currencyAddress
	}

	if (!adminAddresses) {
		return null
	}

	if (provider === 'phantom') {
		return adminAddresses.sol_admin_address?.trim() || null
	}
	if (provider === 'metamask') {
		return adminAddresses.eth_admin_address?.trim() || null
	}

	return null
}
